module.exports = {"pageTitleText":"Tasks","submitTime":"Submit Time","errorMsg":"Error Message","finishedTime":"Finished Time","state":"State","taskNo":"Task No.","trainNo":"Train No.","runCounter":"Run Counter","scopeResult":"Scope Result","scope":"Scope","requestData":"Request Data","originData":"Origin Data","diffData":"Diff Data","objId":"Object ID","decodeObjId":"Object Name","request_source":"Request Source","actionName":"Action Name"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/tasks.json
// module id = LTPM
// module chunks = 3